import React, { useEffect, useContext, useState } from 'react';

import { LoginContext } from '../../hooks/context/LoginContext';

import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Formulario from '../../componentes/formulario/Formulario';
import FormRow from '../../componentes/formulario/FormRow';
import FormInput from '../../componentes/formulario/FormInput';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTable from '../../componentes/ui/MiDataTable';
import { Alert } from '../../componentes/ui/Alert';
import MiSelect from '../../componentes/formulario/MiSelect';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Spinner from 'react-bootstrap/Spinner';

import useLogicForm from '../../hooks/useLogicForm';

import Cookies from 'universal-cookie';

import { Fragment } from 'react';

import { getTitle, getDecodedCookie } from '../../helpers/helperApp';

function EstDoc(props){

    const cookies = new Cookies();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ estadoFormPrin, saveEstadoFormPrin ] = useState("");
    const [ estadoFormHijo, saveEstadoFormHijo ] = useState("");

    // ***** Custom Hook - Lógica de los formularios *****
    const { registrosPrin, saveRegistrosPrin, formularioPrin, saveFormularioPrin, saveFormularioHijo , handleInputForm, handleLastReg, handleEditRegPrin, loadingTable, saveLoadingTable, loadReg, regIniciales, handleDeleteItemPrin, handleSubmitPrin, resetFormPrin, handleSelectFormPrin } = useLogicForm();

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{             
                    document.title = getTitle(confPantalla.config.trad, confPantalla.estdoc.title);                           
                    if( respuesta == 1 ){
                        saveTieneNivel(true);    
                        saveEstadoFormPrin(confPantalla.estdoc.padre.estadoform);
                        saveEstadoFormHijo(confPantalla.estdoc.hijo.estadoform);                         
                        // ***** Carga inicial de registros *****
                        if( registrosPrin ){
                            if( registrosPrin.length === 0 ){
                                saveLoadingTable(true);
                                regIniciales(saveRegistrosPrin, confPantalla.estdoc.padre.urls);
                                saveFormularioPrin(confPantalla.estdoc.padre.modelform);
                                saveFormularioHijo(confPantalla.estdoc.hijo.modelform);     
                            }
                        }  
                        // Seleccionar el id que nos llega como parámetro por la url
                        if( props.location.state ){
                            if( "idPrin" in props.location.state || "idHijo" in props.location.state ){
                                handleLastReg(props.location.state.idPrin, props.location.state.idHijo, confPantalla.estdoc.padre.urls, confPantalla.estdoc.hijo.urls, confPantalla.estdoc.padre.tabla, props.location.state.estadoFormPrin, saveEstadoFormPrin, saveEstadoFormHijo);    
                            }                        
                        }                      
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");
        } 

    },[confPantalla])
 

    return(
        <div className="App wrapper">
            <div>
                {   loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div> 
                    :
                    null
                }
                {
                    !loadReg ?
                        <Alert fondo={true} />
                    :
                        <Alert />
                }                                
            </div>   
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                        <Section titulo={ confPantalla.estdoc.section.titulo } icono={ confPantalla.estdoc.section.icono } col={ confPantalla.estdoc.section.col } idPrin={ formularioPrin.id } wiki={ confPantalla.estdoc.section.wiki } >
                            <Formulario 
                                        estadoForm= { estadoFormPrin }
                                        loading=    { loadReg ? true : false }
                                        btnNew={ confPantalla.estdoc.padre.btnform.new }
                                        btnSave={ confPantalla.estdoc.padre.btnform.save }
                                        btnSaveAndNew={ confPantalla.estdoc.padre.btnform.saveandnew }
                                        btnDelete={ confPantalla.estdoc.padre.btnform.delete }
                                        btnClone={ confPantalla.estdoc.padre.btnform.clone }
                                        handleSubmit = { e => handleSubmitPrin(e, confPantalla.estdoc.padre.urls, confPantalla.estdoc.padre.modelform, confPantalla.estdoc.padre.tabla, confPantalla.estdoc.hijo.modelform, confPantalla.estdoc.title) }
                                        formulario = { formularioPrin } 
                                        resetForm = { e => resetFormPrin(confPantalla.estdoc.padre.modelform, true, confPantalla.estdoc.padre.tabla) } 
                                        handleDeleteItem = { e => handleDeleteItemPrin(undefined, confPantalla.estdoc.padre.urls, confPantalla.estdoc.padre.modelform, confPantalla.estdoc.padre.tabla, confPantalla.estdoc.title) }  
                            >         
                            <h4>{ formularioPrin.ruta }</h4>   
                                <FormRow clases="" >
                                    <MiSelect  
                                        estadoForm=  { estadoFormPrin }
                                        val=         { formularioPrin.pad  }   
                                        loading=     { loadReg ? true : false }
                                        id=          { confPantalla.estdoc.padre.controles.pad.id }    
                                        name=        { confPantalla.estdoc.padre.controles.pad.name }   
                                        label=       { confPantalla.estdoc.padre.controles.pad.label }    
                                        placeholder= { confPantalla.estdoc.padre.controles.pad.placeholder }
                                        col=         { confPantalla.estdoc.padre.controles.pad.col } 
                                        isClearable= { confPantalla.estdoc.padre.controles.pad.isclearable }
                                        isSearchable={ confPantalla.estdoc.padre.controles.pad.issearchable }
                                        dataType=    { confPantalla.estdoc.padre.controles.pad.datatype }
                                        data=        { confPantalla.estdoc.padre.controles.pad.data }
                                        required=    { confPantalla.estdoc.padre.controles.pad.required } 
                                        disabled=    { confPantalla.estdoc.padre.controles.pad.disabled }
                                        readOnly =   { confPantalla.estdoc.padre.controles.pad.readonly }
                                        disablethisid={confPantalla.estdoc.padre.controles.pad.disablethisid}
                                        formulario = { formularioPrin } 
                                        change=      { handleSelectFormPrin }                                                    
                                    />                                    
                                    <FormInput                                                        
                                        estadoForm= { estadoFormPrin }
                                        value=      { formularioPrin.nom }
                                        loading=    { loadReg ? true : false }
                                        id=         { confPantalla.estdoc.padre.controles.nom.id }   
                                        type=       { confPantalla.estdoc.padre.controles.nom.type }  
                                        name=       { confPantalla.estdoc.padre.controles.nom.name }   
                                        label=      { confPantalla.estdoc.padre.controles.nom.label }                                                       
                                        placeholder={ confPantalla.estdoc.padre.controles.nom.placeholder }    
                                        col=        { confPantalla.estdoc.padre.controles.nom.col } 
                                        required=   { confPantalla.estdoc.padre.controles.nom.required }
                                        readonly=   { confPantalla.estdoc.padre.controles.nom.readonly }                                                
                                        disabled=   { confPantalla.estdoc.padre.controles.nom.disabled }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    /> 
                                    <FormInput                                                        
                                        estadoForm= { estadoFormPrin }
                                        value=      { formularioPrin.nom_en }
                                        loading=    { loadReg ? true : false }
                                        id=         { confPantalla.estdoc.padre.controles.nom_en.id }   
                                        type=       { confPantalla.estdoc.padre.controles.nom_en.type }  
                                        name=       { confPantalla.estdoc.padre.controles.nom_en.name }   
                                        label=      { confPantalla.estdoc.padre.controles.nom_en.label }                                                       
                                        placeholder={ confPantalla.estdoc.padre.controles.nom_en.placeholder }    
                                        col=        { confPantalla.estdoc.padre.controles.nom_en.col } 
                                        required=   { confPantalla.estdoc.padre.controles.nom_en.required }
                                        readonly=   { confPantalla.estdoc.padre.controles.nom_en.readonly }                                                
                                        disabled=   { confPantalla.estdoc.padre.controles.nom_en.disabled }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    /> 
                                </FormRow>                            
                            </Formulario>
                            <MiDataTable
                                formulario={formularioPrin}
                                estadoForm= { estadoFormPrin }
                                id={"estdoc"}
                                columnas={confPantalla.estdoc.padre.datatable.columns}
                                data={registrosPrin}
                                buttons={confPantalla.estdoc.padre.datatable.buttons}
                                ordering={confPantalla.estdoc.padre.datatable.ordering}
                                order={confPantalla.estdoc.padre.datatable.order}
                                searching={confPantalla.estdoc.padre.datatable.searching}
                                paging={confPantalla.estdoc.padre.datatable.paging}
                                select={confPantalla.estdoc.padre.datatable.select}
                                pagelength={confPantalla.estdoc.padre.datatable.pagelength}
                                handleEditReg= { e => handleEditRegPrin(e, confPantalla.estdoc.padre.urls, confPantalla.estdoc.hijo.urls, confPantalla.estdoc.padreshijos, confPantalla.estdoc.hijo.modelform, confPantalla.estdoc.padre.tabla) }
                                handleDeleteItem={ e => handleDeleteItemPrin(e, confPantalla.estdoc.padre.urls, confPantalla.estdoc.padre.modelform, confPantalla.estdoc.padre.tabla, confPantalla.estdoc.title) }
                                saveLoadingTable={ saveLoadingTable }
                                loadingTable={loadingTable}
                                columnactions={confPantalla.estdoc.padre.datatable.columnactions.title}
                                traduction={confPantalla.config.trad.components.datatable}
                            />                                                                                                             
                            </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default EstDoc